import uiCore = require("../core/uicore");

export interface IExportFormat {
    Name: string;
    Code: string;
}

export interface IZoomLevel {
    Name: string;
    Scale: number;
}

export var pdfExportFormat: IExportFormat = { Name: "PDF", Code: "PDF" };
export var exportFormats: IExportFormat[] = [
    pdfExportFormat,
    { Name: "Excel", Code: "EXCELOPENXML" },
    { Name: "Word", Code: "WORDOPENXML" },
    { Name: "Tiff", Code: "IMAGE" },
    { Name: "Word 2003", Code: "Word" },
    { Name: "Excel 2003", Code: "Excel" },
]

export var defaultZoomLevel: IZoomLevel = { Name: "100%", Scale: 1.0 }
export var zoomLevels: IZoomLevel[] = [
    { Name: "200%", Scale: 2.0 },
    { Name: "150%", Scale: 1.5 },
    { Name: "125%", Scale: 1.25 },
    defaultZoomLevel,
    { Name: "75%", Scale: 0.75 },
    { Name: "50%", Scale: 0.50 },
    { Name: "25%", Scale: 0.25 },
]

export interface IReportMenuComponentApi {
    title: string;
    selectedExportFormat: IExportFormat;
    selectedZoomLevel: IZoomLevel;
    onRenderReport: () => void;
    onGetExportReportUrl: (exportFormat: IExportFormat) => string;
}

export class ReportMenuBarDirective implements uiCore.IDirective {
    public exportFormats: IExportFormat[] = exportFormats;
    public zoomLevels: IZoomLevel[] = zoomLevels;

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "crewreportmenubar",
        Template: require("./crewreportmenubar.html"),
        AngularDependencies: [uiCore.ScopeDependency],
        Bindings: {
            api: "=",
        },
    }

    public api: IReportMenuComponentApi;

    public onExportReport() {
        this.reportExportUrl = this.api.onGetExportReportUrl(this.api.selectedExportFormat);
        if (this.reportExportUrl && this.reportExportUrl != "") {
            window.open(this.reportExportUrl);
        }
    }

    private reportExportUrl: string = null;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/crewreportmenubar.ts